<template>
  <div>
    <ele-form
      v-model="frender.formPropsData"
      :form-desc="filteredFormDesc"
      :formAttrs="{ size: 'small' }"
      :isShowBackBtn="false"
      :isShowSubmitBtn="false"
      :span="20"
      labelPosition="top"
    ></ele-form>
  </div>
</template>

<script>
import searchMixin from "./components/search-mixin";
import { changeFormDescLabel } from "../../utils";
export default {
  inject: ["frender"],
  mixins: [searchMixin],
  computed: {
    formDesc() {
      return changeFormDescLabel(this.frender.formProps.config);
    }
  }
};
</script>
